import { Deserializable } from '../_common/deserializable';

export class OfferStreamRecord implements Deserializable {
      id: number;
      advertiser: string;
      advertiserId: number;
      offerId: string;
      originAffiliate: string;
      affiliate: string;
      queryString: string;
      uriVariables: string;
      panOutState: number;
      dryPanOutState: number;
      panOutAt: number;
      panOutMsg: string;
      panOutUrl: string;
      panOutBody: string;
      createdAt: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
